import { render, staticRenderFns } from "./TilitysSelaa.vue?vue&type=template&id=c8049a10&scoped=true&"
import script from "./TilitysSelaa.vue?vue&type=script&lang=js&"
export * from "./TilitysSelaa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8049a10",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VProgressLinear,VSpacer,VToolbar,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8049a10')) {
      api.createRecord('c8049a10', component.options)
    } else {
      api.reload('c8049a10', component.options)
    }
    module.hot.accept("./TilitysSelaa.vue?vue&type=template&id=c8049a10&scoped=true&", function () {
      api.rerender('c8049a10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TilitysSelaa.vue"
export default component.exports